module.exports = __webpack_public_path__ + "img/perfil_hiperlordotico.f324f816.jpg";